import { get } from 'object-path-immutable';
import { STACK } from 'lib/block';
import {
  addTheme as addTextTheme,
  overrides as textOverrides,
  extractStyles as extractTextStyles,
} from './text';
import {
  addTheme as addImageTheme,
  overrides as imageOverrides,
  extractStyles as extractImageStyles,
} from './image';
import {
  calculateOverridePaths,
  styleToThemeStyle,
  augmentedWrap,
} from './utils';

const PATHS = {
  root: 'style',
  image: 'items.0.items.0',
  image_old: 'items.0',
  title: 'items.1.items.0',
  subtitle: 'items.1.items.1',
};

export const addTheme = (content, selectedVariant, preserveOverrides) => {
  const updated = augmentedWrap(content)
    .set(
      PATHS.title,
      addTextTheme(
        content.items[1].items[0],
        `${selectedVariant}.title`,
        preserveOverrides
      )
    )
    .updateStyle(
      PATHS.root,
      {
        theme: selectedVariant,
        horizontalAlignment: 'leading',
        verticalAlignment: 'center',
      },
      preserveOverrides
    );

  if (content.items[0].type === STACK) {
    updated.set(
      PATHS.image,
      addImageTheme(
        content.items[0].items[0],
        `${selectedVariant}.image`,
        preserveOverrides
      )
    );
  } else {
    // old template
    updated.set(
      PATHS.image_old,
      addImageTheme(
        content.items[0],
        `${selectedVariant}.image`,
        preserveOverrides
      )
    );
  }

  if (content.items[1].items[1]) {
    updated.set(
      PATHS.subtitle,
      addTextTheme(
        content.items[1].items[1],
        `${selectedVariant}.subtitle`,
        preserveOverrides
      )
    );
  }

  return updated.value();
};

export const overrides = ({ compiledTheme, content }) =>
  [
    calculateOverridePaths({
      compiledTheme,
      content,
      path: PATHS.root,
      ignore: ['horizontalAlignment', 'verticalAlignment'],
    }),
    imageOverrides({
      compiledTheme,
      content,
      path: content.items[0].type === STACK ? PATHS.image : PATHS.image_old,
      pathName: 'image',
    }),
    textOverrides({
      compiledTheme,
      content,
      path: PATHS.title,
      pathName: 'title',
    }),
    content.items[1].items[1]
      ? textOverrides({
          compiledTheme,
          content,
          path: PATHS.subtitle,
          pathName: 'subtitle',
        })
      : [],
  ].flat();

export const extractStyles = content => ({
  $style: styleToThemeStyle({
    style: get(content, PATHS.root),
    ignore: ['horizontalAlignment', 'verticalAlignment'],
  }),
  title: extractTextStyles(get(content, PATHS.title)),
  // if the subtitle is turned off, use the title style
  subtitle: extractTextStyles(
    get(content, content.items[1].items[1] ? PATHS.subtitle : PATHS.title)
  ),
  image: extractImageStyles(
    get(
      content,
      content.items[0].type === STACK ? PATHS.image : PATHS.image_old
    )
  ),
});
